import { Injectable, InjectionToken } from '@angular/core';
import {BrandList, MODE, TourInclude} from '../models';
import {HotelToursSearchParams} from "../types/interfaces/hotel-tour-search";

export interface IAppPhoneConfig {
  number: string;
  beautifulNumber: string;
}

@Injectable()
export class HotelToursPageConfig {
  autoStartSearch = true;
  // Brand id
  brandId: number;
  // Режим работы
  mode = '';
  // Ссылка на страницу просмотра тура, GET параметры динамические
  tourViewUrl: string;
  // Показывать цену на одного
  isShowPriceByOne = true;
  // Делать поиск по фильтрам
  searchByFilters: boolean;
  // Ссылка на заглушку фотографии
  noPhotoLink: string;
  // Базовый путь до картинки отеля
  photoBasePath: string;
  // Конфигурация отображаемого номера телефона в выдаче
  phone?: IAppPhoneConfig;
  // Показывать поле поиска по названию отеля
  isShowHotelSearchInput = true;
  // Показывать туры по нажатию "Еще туры"
  isShowSameTours = false;
  // Отрисовывать фильтры
  isRenderFilters = true;
  // Отрисовывать шапку (сколько найдена, данные поиска, минимальная цена и т.д.)
  isRenderTitle = true;
  // Отрисовывать краткую информацию о туре
  isRenderShortTour = false;
  // Ссылка откуда загружать туры
  loadToursUrl?: string;
  // Параметры для loadToursUrl
  loadToursParams?: any;
  // Символ валюты во вьюхах компонентов
  currencySign: string;
  // Код валюты
  currencySignCode: string;
  // Символы валют
  currencySigns: string;
  // Наименование селектора до которого скролить при пагинации
  paginationScrollToSelectorId?: string;
  // Максимальное количество кнопок пагинации отображаемое в компоненте пагинации
  paginationMaxButtonCount: number;
  // Использовать постраничную навигацию вместо бесконечной подгрузки туров
  isToursPaginationEnabled = true;
  // Доступность слайдера фоток отеля
  isPhotoSliderAvailable: boolean;
  // Показывать процент скидки
  isShowDiscount = true;
  // Ручная скидка
  manualDiscount: number;
  // Отрисовывать график цен на отель
  isRenderHotelPriceCalendar: false;

  isAllowSmartFilters: boolean;

  // Что входит в туры
  tourIncludes = [
    TourInclude.FLIGHT,
    TourInclude.TRANSFER,
    TourInclude.HOTEL,
    TourInclude.MEAL,
    TourInclude.TOUR_CODE,
    TourInclude.INSURANCE,
  ];

  // отрисовывывать блок "Воспользуйтесь фильтрами" между турами
  isRenderFilterHelp = true;
  // отрисовывывать блок "Заказать звонок" между турами
  isRenderCallbackHelp = true;
  // отрисовывывать блок "что включено" между турами
  isRenderTourIncludesHelp = true;
  // включены ли кредиты
  isCreditEnabled = false;
  // кредитные условия
  creditTerms: any = {};
  // отрисовывать лоадер при ajax запросе
  isRenderAjaxLoader = false;
  // id страны по которой по умолчанию делаем поиск по отелям
  defaultSuggestHotelCountryId = null;
  // HTML для компонента коллбека
  callbackComponentHTML: string = null;
  // отрисовывать баннер про онлайн бронирование
  isRenderOnlineBooking = true;
  // Нужна ли прокрутка к началу выдачи при старте первого поиска
  isNeedScrollToTableTopOnFirstSearch = true;
  // показывать баннера про персонального менеджера и кэшбек
  isShowManagerAndCashbackBanners = false;
  // отрисовывать баннер про персонального менеджера
  isRenderPersonalManager = true;
  // отрисовывать баннер про кэшбек для каждого тура
  isRenderTourCashback = true;
  isWishlist: boolean;
  isClientAuth: boolean;
  searchDefaultSortVariant: string;
  // Поиск отеля
  isSearchByHotel = false;
  httpSearchUrl: string;
  httpV2SearchUrl: string;
  pageSize: number;
  language: string;
  guideBanners: {};
  travelFeed: {
    experimentId: string;
    variant: string | null;
    isQa: boolean;
    eligible: boolean;
    placement: 'after-first-tour' | 'after-results' | null;
    conversionWindowDays: number;
    siteCityId: number | null;
    url: string | null;
    label: string;
    title: string;
    subtitle: string;
    countries: Record<number, {title: string; url: string; alias: string}>;
    stub: string;
    button: string;
  };
  translates: {
    toursNotFound: {},
    toursNotFoundMobile: {},
    map: {
      viewModeList: string,
      viewModeMap: string,
    },
    toursTotal: {},
    toursSort:  {
      sortByPriceText: string,
      sortByPopularText: string,
      cheaperFirstText: string,
      popularFirstText: string,
      popularText: string,
      sortByRatingText: string,
      wratingText: string,
      sortByPriceQualityText: string,
      sortToursText: string,
    },
    tourLoader: {},
    pagination: {
      toBeginText: string,
      toEndText: string,
      prevText: string,
      nextText: string,
    },
    incorrectFilters: {},
    tourInclude: {},
    tourCallback: {},
    tourFilterHelp: {},
    tourImage: {},
    tourRecommendations: {},
    tourInfo: {},
    searchProgress: { tours: string; hotels: string; },
    tourPrices: {},
    hotelServices: {},
    plurals: {
      reviewsPlural: string[],
      pluralTours: string[],
      oncePlural: string[],
      daysPlural: string[],
    },
    filters: {
      showOnMap: string,
      closeMap: string,
      filtersByCriteria: string,
      hotelOnMap: string,
      resetFilters: string,
      applyFilters: string,
      filtersText: string,
      findHotelText: string,
      filterText: string,
      showHotels: string,
      confirmText: string,
      confirmResetText: string,
      confirmNo: string,
      confirmYes: string,
      seaLine: string,
      findHotelByName: string,
      searchHotelText: string,
      searchHotelNameText: string,
    },
    timeOutPopup: {
      latestPrices: string,
      updateResults: string,
      refreshSearch: string,
    },
    viewTour: string,
    moreDetails: string,
    hotelViewCount: string,
    wishlist: {
      wishlistHotelPopup: {
        successLabel: string,
        doneLabel: string,
        hotelAddedText: string,
        hotelRemovedText: string,
        toCabinetText: string,
      },
      wishlistAuthModal: {
        titleText: string,
        hintText: string,
        toCabinetText: string,
      }
    },
  };
  isShowHotelViewCount: boolean;
  isShowRecommendedTours: boolean;
  searchDefaultSortTestVariant: string;
  searchFormValues: HotelToursSearchParams;
  trackedTourHashes: Record<string, string>;
  btnToTourDetailsLabel: string;
  hotel: {
    hotelId: number,
    hotelName: string,
    hotelAlias: string,
    countryName?: string,
    countryAlias?: string,
    regionName?: string,
    regionAlias?: string,
  };
  directionDepartCities: Array<{
    id: number,
    name: string,
    nameGenitive?: string,
    alias?: string,
    countryId?: number,
    alternativeId?: number | null,
  }>;
  searchFormDirection: {
    nights: number[]
  }

  constructor() {
    const params = (window as any).angularParams;

    this.brandId = params.brandId;
    this.mode = params.mode;
    this.tourViewUrl = params.tourViewUrl;
    this.isShowPriceByOne = params.isShowPriceByOne;
    this.isShowHotelSearchInput = params.isShowHotelSearchInput;
    this.isShowSameTours = params.isShowSameTours;
    this.isRenderFilters = params.isRenderFilters;
    this.isRenderShortTour = params.isRenderShortTour;
    this.isRenderTitle = params.isRenderTitle;
    this.searchByFilters = params.searchByFilters;
    this.currencySign = params.currencySign;
    this.currencySignCode = params.currencySignCode;
    this.currencySigns = params.currencySigns;
    this.noPhotoLink = params.noPhotoLink;
    this.photoBasePath = params.photoBasePath;
    this.paginationScrollToSelectorId = params.paginationScrollToSelectorId;
    this.paginationMaxButtonCount = params.paginationMaxButtonCount;
    this.isToursPaginationEnabled = params.isToursPaginationEnabled !== false;
    this.defaultSuggestHotelCountryId = params.defaultSuggestHotelCountryId;

    this.isRenderFilterHelp = params.isRenderFilterHelp;
    this.isRenderCallbackHelp = params.isRenderCallbackHelp;
    this.isRenderTourIncludesHelp = params.isRenderTourIncludesHelp;
    this.isRenderAjaxLoader = params.isRenderAjaxLoader;
    this.isRenderOnlineBooking = params.isRenderOnlineBooking;

    this.isCreditEnabled = params.isCreditEnabled;
    this.creditTerms = params.creditTerms;
    this.callbackComponentHTML = params.callbackComponentHTML;
    this.isShowDiscount = params.isShowDiscount;
    this.isPhotoSliderAvailable = params.isPhotoSliderAvailable;
    this.manualDiscount = params.manualDiscount;
    this.isRenderHotelPriceCalendar = params.isRenderHotelPriceCalendar;
    this.isNeedScrollToTableTopOnFirstSearch = params.isNeedScrollToTableTopOnFirstSearch;
    this.isSearchByHotel = params.isSearchByHotel;
    this.httpSearchUrl = params.httpSearchUrl;
    this.httpV2SearchUrl = params.httpV2SearchUrl;
    this.pageSize = params.pageSize;
    this.translates = params.translates;
    this.language = params.language;
    this.isShowRecommendedTours = params.isShowRecommendedTours;
    this.isShowHotelViewCount = params.isShowHotelViewCount;
    this.guideBanners = params.guideBanners;
    this.travelFeed = params.travelFeed;
    this.btnToTourDetailsLabel = params.btnToTourDetailsLabel;
    this.searchFormValues = params.searchFormValues ?? {} as HotelToursSearchParams;
    this.trackedTourHashes = params.trackedTourHashes ?? {};
    this.searchFormValues.hotelsSearch = this.resolveHotelsSearch(this.searchFormValues);
    this.searchFormDirection = params.searchFormDirection;
    this.directionDepartCities = params.directionDepartCities ?? [];
    this.hotel = params.hotel;
    this.searchDefaultSortVariant = params.searchDefaultSortVariant;
    this.isClientAuth = params.isClientAuth;
    this.isWishlist = params.isWishlist;
    this.isRenderTourCashback = params.isRenderTourCashback;
    this.isShowManagerAndCashbackBanners = params.isShowManagerAndCashbackBanners;
    this.isRenderPersonalManager = params.isRenderPersonalManager;
    this.isAllowSmartFilters = params.isAllowSmartFilters;

    if (params.hasOwnProperty('tourIncludes')) {
      this.tourIncludes = params.tourIncludes;
    }
    if (params.hasOwnProperty('phone')) {
      this.phone = params.phone;
    }
    if (params.hasOwnProperty('loadToursUrl')) {
      this.loadToursUrl = params.loadToursUrl;
    }
    if (params.hasOwnProperty('loadToursParams')) {
      this.loadToursParams = params.loadToursParams;
    }
    if (params.hasOwnProperty('isNeedScrollToTableTopOnFirstSearch')) {
      this.isNeedScrollToTableTopOnFirstSearch = params.isNeedScrollToTableTopOnFirstSearch;
    }
    if (params.hasOwnProperty('autoStartSearch')) {
      this.autoStartSearch = params.autoStartSearch;
    }
  }

  private resolveHotelsSearch(searchFormValues: HotelToursSearchParams): number {
    if (searchFormValues?.hotelsSearch) {
      return 1;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const hotelsSearch = queryParams.get('hotelsSearch');

    if (hotelsSearch === null) {
      return 0;
    }

    return ['1', 'true', 'yes'].includes(hotelsSearch.toLowerCase()) ? 1 : 0;
  }
}

export const HOTEL_TOURS_PAGE_CONFIG = new InjectionToken<HotelToursPageConfig>('HOTEL_TOURS_PAGE_CONFIG');
